import React from 'react'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/images'
import './Intro.css'

const Intro = () => {
  const { t } = useTranslation()
  const benefits = t('academyIntro.benefitsList', { returnObjects: true }) || []

  return (
    <section className='academy-intro' id='home'>
      <div className='academy-intro-content'>
        <p className='academy-intro-label'>{t('academyIntro.label')}</p>

        <h1>
          {t('academyIntro.title')}
          <span>{t('academyIntro.titleHighlight')}</span>
          {t('academyIntro.titleEnd')}
        </h1>

        <p className='academy-intro-description'>{t('academyIntro.description')}</p>

        <ul className='academy-intro-benefits'>
          {benefits.map((item, index) => (
            <li key={index}>
              <img className='check' src={Images.icons.circleCheck2} alt='check' />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <button
          className='academy-intro-cta'
          type='button'
          onClick={() => window.location.href = 'mailto:hello@tiimapp.com'}
        >
          {t('academyIntro.button')}
        </button>

        <img className='academy-intro-image desktop-image' src={Images.academy.introDesktop} alt='academy intro' />
        <img className='academy-intro-image mobile-image' src={Images.academy.introMobile} alt='academy intro mobile' />


      </div>
    </section>
  )
}

export default Intro
